export class ProjectJira {
  constructor(private readonly projectKey: string | null, private readonly issueTypeKey: string | null, private readonly issueCollectorCode: string | null) {}

  getProjectKey() {
    return this.projectKey;
  }

  getIssueTypeKey() {
    return this.issueTypeKey;
  }

  getIssueCollectorCode() {
    return this.issueCollectorCode;
  }
}
